import React, { useState } from "react";
import "./MyTechProfileFooter.css";
import StarIcon from "@mui/icons-material/Star";
import GlassyButton from "./GlassyButton";
import ContactDrawer from "./ContactDrawer";
import { useSelector } from "react-redux";

const MyTechProfileFooter = ({ contactsRef }) => {
  const { profile } = useSelector((state) => state.editMyTechProfileStore);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const CircularText = ({ text, radius }) => {
    const characters = text.split("");
    const degreeIncrement = 360 / characters.length;

    return (
      <div
        className="mytechprofileFooterComponent-circular-text-container"
        style={{ width: radius * 2, height: radius * 2 }}
      >
        {characters.map((char, index) => (
          <span
            key={index}
            style={{
              transform: `rotate(${
                index * degreeIncrement
              }deg) translate(${radius}px) rotate(90deg)`,
            }}
          >
            {char}
          </span>
        ))}
      </div>
    );
  };

  return (
    <footer
      ref={contactsRef}
      className="mytechprofileFooterComponent-container"
    >
      <div className="mytechprofileFooterComponent-gradient-bg"></div>

      <h2 className="mytechprofileFooterComponent-title">
        {profile?.contactDetails?.title}
      </h2>

      <div className="mytechprofileFooterComponent-rotating-circle-container">
        <div className="mytechprofileFooterComponent-rotating-circle">
          <StarIcon
            className="mytechprofileFooterComponent-star-icon"
            size={30}
          />
          <div className="mytechprofileFooterComponent-circular-text-wrapper">
            <CircularText text="OPEN TO WORK • OPEN TO WORK • " radius={70} />
          </div>
        </div>
      </div>
      <div className="mytechprofileFooterComponent-cta-button">
        <GlassyButton text={"Let's Connect"} onClick={toggleDrawer} />
      </div>

      <p className="mytechprofileFooterComponent-main-text">
        {profile?.contactDetails?.availabilityTitle}
      </p>
      <p className="mytechprofileFooterComponent-subtitle">
        {profile?.contactDetails?.availabilitySubtitle}
      </p>

      <p className="mytechprofileFooterComponent-footer-line">
        {profile?.contactDetails?.footerLine}
      </p>

      <ContactDrawer isOpen={isDrawerOpen} onClose={toggleDrawer} />
    </footer>
  );
};

export default MyTechProfileFooter;
